import { render } from "./MastHead.vue?vue&type=template&id=87a4a4e8"
import script from "./MastHead.vue?vue&type=script&lang=js"
export * from "./MastHead.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__